import { render, staticRenderFns } from "./cont-us.vue?vue&type=template&id=3d88c655&scoped=true&"
var script = {}
import style0 from "./cont-us.vue?vue&type=style&index=0&id=3d88c655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88c655",
  null
  
)

export default component.exports